import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import routes from "./routes";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        {routes.map((route, i) => (
          <Route key={i} path={route.path} element={<route.element />}></Route>
        ))}
      </Routes>
    </Router>
  );
}
export default App;
